// Add your custom JS here.

jQuery(document).ready(function($){
  $('.slick-customers').slick({
    autoplay: true,
    infinite: true,
  	slidesToShow: 8,
  	slidesToScroll: 1,
  	arrows: false,
  	dots: false
  });
  
  
   $('.slick-fmg-products').slick({
    autoplay: true,
    infinite: true,
  	slidesToShow: 1,
  	slidesToScroll: 1,
  	arrows: true,
  	dots: true,
  	speed: 900,
  	autoplaySpeed: 6000
  });
   
  
  
  
  
  $(function () {
  $(document).scroll(function () {
    var $nav = $(".fixed-top");
    $nav.toggleClass('scrolled', $(this).scrollTop() > $nav.height());
  });
});


});


